import { mer } from '@/restore/reports/mer';
import { formatDateParams } from '../libs/time';
import { settingsMerParams } from '@/store/reports/libs/formats/merParams';

/*
    Модель для МЕР фильтра.
*/

export const merFilterReportModel = {
    name: 'merFilterReport',
    state: {},
    reducers: {},
    effects: () => ({
        getFilterParams(reportTypePath) {
            const filterParams = mer.getMerParams();
            const { intervalId, period, date, ...otherParams } = filterParams;

            const pathWithSuffix = addSuffix(reportTypePath, intervalId);

            const result = {
                reportType: pathWithSuffix,
            };

            const dateParams = formatDateParams(period, date);
            const formattedDateParams = {
                ...dateParams,
                MonthBegin: dateParams.MonthBegin < 10 ? `0${dateParams.MonthBegin}` : String(dateParams.MonthBegin),
                MonthEnd: dateParams.MonthEnd < 10 ? `0${dateParams.MonthEnd}` : String(dateParams.MonthEnd),
            };
            const commonParams = settingsMerParams(otherParams);

            Object.assign(result, formattedDateParams, commonParams);

            return result;
        },
    }),
};

/*
    Добавляет к пути суффикс _intervalId к общему пути для отчета
*/
function addSuffix(path, intervalId) {
    if (!intervalId) {
        return path;
    }
    // Что такое intervalId?
    return `${path}_${intervalId}`;
}
